import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { GoodieGiveawayTabs as TabsComponent } from 'swag-client-common/components/partials/goodie-giveaway-tabs';
import { GoodieGiveawayTabsSelect as SelectComponent } from 'swag-client-common/components/partials/goodie-giveaway-tabs-select';
import { goodieGiveawayCategoriesListSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-categories.selectors';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { pathnameSelector } from '../../../redux/routing/routing.selectors';
import { giveawayLinkItemItemSelector, giveawayTypeLandingSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
const DATA_ATTRIBUTE_ALL_CATEGORIES = 'allCategories';
const tabsSelector = createSelector(goodieGiveawayCategoriesListSelector, giveawayLinkItemItemSelector, giveawayTypeLandingSelector, (categoriesList, item, giveawayType) => {
  const BASE_ROUTE = `${GiveawayUrl.getGiveawayUserLanding({
    link: (item === null || item === void 0 ? void 0 : item.link) || '',
    giveawayType
  })}`;
  const ALL_GIFTS_TAB = {
    text: 'All Goodies',
    route: BASE_ROUTE,
    categoryId: DATA_ATTRIBUTE_ALL_CATEGORIES
  };
  if (!categoriesList) {
    return [ALL_GIFTS_TAB];
  }
  return categoriesList.reduce((tabs, {
    name,
    slug,
    _id
  }) => [...tabs, {
    text: name,
    route: `${BASE_ROUTE}/${slug}`,
    categoryId: _id
  }], [ALL_GIFTS_TAB]);
});
const currentTabSelector = createSelector(pathnameSelector, tabsSelector, (pathname, tabs) => {
  const selectedTab = tabs.find(({
    route
  }) => route === pathname);
  return selectedTab || tabs[0];
});
const mapStateToProps = createStructuredSelector({
  currentTab: currentTabSelector,
  tabs: tabsSelector,
  giveawayColor: selectedGiveawayColorWithFallbackSelector
});
export const GiveawayLandingGoodieCategories = connect(mapStateToProps)(TabsComponent);
export const GoodieGiveawayTabsSelect = connect(mapStateToProps)(SelectComponent);